// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__3QbRB","collection-cta":"styles-m__collection-cta__3iVib"};